/** A legacy backfill writer generated untagged samples in all four real buckets.
 * Withhold the entire affected interval until record-level provenance is recovered.
 * This is a read filter; stored records are never changed or deleted.
 */
export const RFIMS_HISTORY_EXCLUSION = {
  start: '2026-06-05T00:00:00.000Z',
  end: '2026-08-24T00:00:00.000Z',
  reason: 'Legacy synthetic backfill may be mixed with measurements; provenance is unverified.',
} as const;

const startMs = Date.parse(RFIMS_HISTORY_EXCLUSION.start);
const endMs = Date.parse(RFIMS_HISTORY_EXCLUSION.end);

export function isExcludedRfimsSample(timeMs: number): boolean {
  return timeMs >= startMs && timeMs < endMs;
}

/** Reject old/cached summaries whose contributing window could contain backfill. */
export function isExcludedRfimsWindow(endTimeMs: number, durationMs: number): boolean {
  return durationMs > 0
    ? endTimeMs > startMs && endTimeMs - durationMs < endMs
    : isExcludedRfimsSample(endTimeMs);
}

export function rfimsHistoryExclusions(days: number, now = Date.now()) {
  return now > startMs && now - days * 86_400_000 < endMs ? [RFIMS_HISTORY_EXCLUSION] : [];
}

/** Push trusted ranges into Influx's storage scan instead of filtering every raw row. */
export function rfimsMeasuredRanges(start: number, end: number): Array<{ start: number; end: number }> {
  if (end <= startMs || start >= endMs) return [{ start, end }];
  const ranges = [];
  if (start < startMs) ranges.push({ start, end: startMs });
  if (end > endMs) ranges.push({ start: endMs, end });
  return ranges;
}
